import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 5000,
});

// ── Lecture du statut d'une application ──────────────────────
export const getAppStatus = (app) =>
  api.get(`/api/status/${app}`).then(r => r.data);

// ── Programme réellement chargé dans le PLC ─────────────────
export const getProgramIdentity = () =>
  api.get('/api/system/program-identity').then(r => r.data);

// ── Forcer un bit (capteur) d'une application ────────────────
export const setAppBit = (app, bit, state, token = null, correlationId = null) => {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  if (correlationId) headers['X-Correlation-ID'] = correlationId;
  return api.post(`/api/${app}/bit/${bit}/${state}`, null, { headers }).then(r => r.data);
};

// ── Remettre à zéro tous les bits forcés d'une application ───
export const releaseAllAppBits = (app) =>
  api.post(`/api/${app}/release-all`).then(r => r.data);

// ── Historique ──────────────────────────────────────────────
export const getHistory = (application = null, variable = null, limit = 200) => {
  const params = { limit };
  if (application) params.application = application;
  if (variable) params.variable = variable;
  return api.get('/api/history', { params }).then(r => r.data);
};

// ── Alarmes ───────────────────────────────────────────────────
export const getAlarms = (unacknowledgedOnly = false) =>
  api.get('/api/alarms', { params: { unacknowledged_only: unacknowledgedOnly } })
     .then(r => r.data);

export const acknowledgeAlarm = (id) =>
  api.post(`/api/alarms/${id}/acknowledge`).then(r => r.data);

// ── Compteurs cumulatifs persistants ──────────────────────────
export const getCounter = (application, name) =>
  api.get(`/api/counters/${application}/${name}`).then(r => r.data);

export const incrementCounter = (application, name) =>
  api.post(`/api/counters/${application}/${name}/increment`).then(r => r.data);

// ── Journal persistant ──────────────────────────────────────────
export const getLogs = (application = null, limit = 100) => {
  const params = { limit };
  if (application) params.application = application;
  return api.get('/api/logs', { params }).then(r => r.data);
};

export const addLog = (application, message, level = "INFO") =>
  api.post('/api/logs', null, { params: { application, message, level } }).then(r => r.data);

// ── Historique de courbe (ex: niveau du réservoir) ────────────
export const getLevelHistory = (application, variable = "niveau", limit = 200) =>
  api.get(`/api/level-history/${application}`, { params: { variable, limit } }).then(r => r.data);

export const addLevelPoint = (application, value, variable = "niveau") =>
  api.post(`/api/level-history/${application}`, null, { params: { value, variable } }).then(r => r.data);

// ── WebSocket — URL dynamique selon l'application ────────────
export const getWsUrl = (app) => {
  const wsBase = BASE_URL.replace('http', 'ws');
  return `${wsBase}/ws/live/${app}`;
};
